/* Gray Market Airsoft — predictive-search.js
   Live search overlay via /search/suggest.json */

(function () {
  'use strict';

  const input = document.getElementById('search-input');
  const results = document.getElementById('predictive-results');
  if (!input || !results) return;

  let debounceTimer;

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    if (!q) { results.innerHTML = ''; return; }
    debounceTimer = setTimeout(() => fetchSuggestions(q), 200);
  });

  async function fetchSuggestions(q) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,sku,tag`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      renderResults(data.resources?.results?.products || []);
    } catch (e) {
      results.innerHTML = '';
    }
  }

  function renderResults(products) {
    if (!products.length) {
      results.innerHTML = '';
      return;
    }
    results.innerHTML = `
      <div style="background:var(--black-2);border:1px solid var(--steel);border-top:none;max-height:360px;overflow-y:auto;">
        ${products.slice(0, 6).map(p => `
          <a href="${p.url}" role="option"
             style="display:grid;grid-template-columns:56px 1fr;gap:12px;padding:12px 16px;border-bottom:1px dashed var(--steel-2);text-decoration:none;align-items:center;">
            ${p.image ? `<img src="${p.image}" alt="" width="56" height="56" style="width:56px;height:56px;object-fit:cover;border:1px solid var(--steel);">` : '<div style="width:56px;height:56px;background:var(--ink-2);border:1px solid var(--steel);"></div>'}
            <div>
              <div class="t-head" style="font-size:13px;color:var(--paper);">${p.title}</div>
              <div class="t-mono" style="font-size:11px;color:var(--od-pale);">${formatMoney(p.price)}</div>
            </div>
          </a>
        `).join('')}
        <a href="/search?type=product&q=${encodeURIComponent(input.value)}"
           style="display:block;padding:12px 16px;text-align:center;font-family:var(--f-mono);font-size:11px;text-transform:uppercase;letter-spacing:0.1em;color:var(--hazard);text-decoration:none;">
          VIEW ALL RESULTS &rarr;
        </a>
      </div>
    `;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Submit search on Enter
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const q = input.value.trim();
      if (q) window.location.href = `/search?type=product&q=${encodeURIComponent(q)}`;
    }
  });

  // Close results on click outside
  document.addEventListener('click', (e) => {
    if (!results.contains(e.target) && e.target !== input) {
      results.innerHTML = '';
    }
  });

})();
